import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import * as Glob from "src/Globale";
import { Trad } from "src/components";

interface IStatusBarProps {
    Value: number;
    Label: string;
    Max: number;
}

const useStyles = makeStyles(({ palette }: Theme) => ({
    root: {
        height: 10,
        backgroundColor: palette.grey[300]
    },
    bar: {
        borderRadius: 20
    }
}));

export const _StatusBar: React.FC<IStatusBarProps> = ({ Value, Label, Max }) => {
    const percentageValue = Number(((100 / Max) * Value).toFixed(0));

    const useBarStyles = makeStyles({
        status: {
            backgroundColor: Glob.GetColorForPercentage(percentageValue / 100, percentageValue, 100, undefined, 0.9)
        }
    });
    const classes = { ...useStyles(), ...useBarStyles() };

    return (
        <>
            <Typography variant="subtitle1" gutterBottom>
                {Trad.Trad(Label)}
            </Typography>
            <Box display="flex" alignItems="center">
                <Box width="100%" mr={2}>
                    <LinearProgress
                        variant="determinate"
                        value={percentageValue}
                        classes={{
                            root: classes["root"],
                            bar: `${classes["bar"]} ${classes["status"]}`
                        }}
                    />
                </Box>
                <Box minWidth={35}>
                    <Typography variant="body2" color="textSecondary">{`${percentageValue}%`}</Typography>
                </Box>
            </Box>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/Charts/StatusBar.tsx